import { lazy } from 'react';

// ----------------------------------------------------------------------

const EditOfferPage = lazy(() => import('../pages/EditOffer.page'));
const ComplaintsPage = lazy(() => import('../pages/Complaints.pag'));
const AddOfferPage = lazy(() => import('../pages/AddOffer.page'));
const OffersPage = lazy(() => import('../pages/Offers.page'));

// ----------------------------------------------------------------------

const OffersRoutes = [
    {
        path: 'offers',
        children: [
            {
                element: <OffersPage />,
                layout: 'default',
                isAuthReq: true,
                index: true,
            },
            {
                path: 'edit-offer/:id',
                element: <EditOfferPage />,
                layout: 'default',
                isAuthReq: true,
            },
            // {
            //     path: 'add-offer',
            //     element: <AddOfferPage />,
            //     layout: 'default',
            //     isAuthReq: true,
            // },
        ],
    },
];

export { OffersRoutes };
